import React, { useEffect, useState } from "react";
import { CardContent, Typography, Stack, Box, Avatar } from "@mui/material";
import Events from "../../assets/images/event_available.png";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { useNavigate } from "react-router-dom";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import axios from "axios";

function ScheduledWorkOrder({ response }) {
  const navigate = useNavigate();
  const [scheduledCount, setScheduledCount] = useState(0);
  const handleClick = () => {
    navigate("/workorder", {
      state: {
        tab: 1,
      },
    });
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const year = new Date().getFullYear();
  //       const month = new Date().getMonth() + 1; // Months are 0-indexed in JavaScript
  //       console.log("month", month);
  //       console.log("year", year);
  
  //       const token = getAuthToken("id_token");
  //       const config = {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       };
  
  //       const departmentid =
  //         localStorage.getItem("roleName") === "DeptUser"
  //           ? 1
  //           : localStorage.getItem("roleName") === "Technician"
  //           ? 2
  //           : 0;
  //       const userid = localStorage.getItem("UserId");
  //       const facilityid = localStorage.getItem("facilityId"); // Ensure this exists
  
  //       if (!facilityid || !userid) {
  //         console.error("Missing facilityId or userId");
  //         return;
  //       }
  
  //       // Define API endpoints
  //       const apiUrlFEMS = `${FemsGraph}/api/Graphfemworkorder/GetWorkOrderCount/${facilityid}/${year}/${month}/${departmentid}/${userid}/${token}`;
  //       const apiUrlBEMS = `${BemsGraph}/api/Graphbemworkorder/GetWorkOrderCountsAsync/${facilityid}/${year}/${month}/${departmentid}/${userid}/${token}`;
  
  //       // Fetch data asynchronously
  //       const [responseFEMS, responseBEMS] = await Promise.all([
  //         axios.get(apiUrlFEMS, config),
  //         axios.get(apiUrlBEMS, config),
  //       ]);
  
  //       const femsCounts = responseFEMS.data || {
  //         totalCount: 0,
  //         scheduledCount: 0,
  //         unscheduledCount: 0,
  //         workrequestCount: 0,
  //         pdmscheduledCount: 0,
  //         rischeduledCount: 0,
  //       };
  
  //       const bemsCounts = responseBEMS.data || {
  //         totalCount: 0,
  //         scheduledCount: 0,
  //         unscheduledCount: 0,
  //         workrequestCount: 0,
  //         pdmscheduledCount: 0,
  //         rischeduledCount: 0,
  //       };
  
  //       const scheduledCount =
  //         (femsCounts.scheduledCount || 0) + (bemsCounts.scheduledCount || 0);
     
  //       setScheduledCount(scheduledCount);
     
  //     } catch (error) {
  //       console.error("Error fetching work order counts:", error);
  //     }
  //   };
  
  //   fetchData();
  // }, []); // Add dependencies if needed
  

  return (
    <>
      <StyledCard sx={{ cursor: "pointer" }}>
        <CardContent onClick={handleClick}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Box>
              <Typography mb={1} variant="subtitle1" color={"text.primary"}>
                Scheduled WO
              </Typography>
              <Typography m={0} variant="h1" color={"success.dashboard"}>
                {/* {localStorage.getItem("roleName") === "Technician"
                  ? scheduledCount
                  : response?.totalScheduledWorkOrderCount} */}
                  {response?.totalScheduledWorkOrderCount}
              </Typography>
            </Box>
            <Box bgcolor={"success.dashboard"} p={1} borderRadius={50}>
              <Avatar
                alt="Remy Sharp"
                src={Events}
                sx={{ width: 24, height: 24 }}
              ></Avatar>
            </Box>
          </Stack>
        </CardContent>
      </StyledCard>
    </>
  );
}

export default ScheduledWorkOrder;
